import { render, staticRenderFns } from "./allocationOrderEdit.vue?vue&type=template&id=d006c4b2"
import script from "./allocationOrderEdit.vue?vue&type=script&lang=js"
export * from "./allocationOrderEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports